import { ActionBarItemGroup, Button, rem } from '@innovyze/stylovyze';
import {
	EditSensorDataSort,
	SensorDataPoint,
} from '@Types/editSensorData.types';

import { FormikProps } from 'formik';
import React from 'react';
import { editSensorDataPoints } from '@Actions/sensors';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

export interface DeleteModalFooterProps {
	closeDeleteModal: () => void;
	goToSensorEdit: () => void;
	formRef: React.MutableRefObject<
		| FormikProps<{
				points: SensorDataPoint[];
				sort: EditSensorDataSort;
		  }>
		| undefined
	>;
}
export const DeleteModalFooter = ({
	goToSensorEdit,
	closeDeleteModal,
	formRef,
}: DeleteModalFooterProps) => {
	const { sensorId } = useParams<{ sensorId: string }>();
	const values = formRef?.current?.values;
	const dispatch = useDispatch();
	return (
		<>
			<Button
				variant="contained"
				color="error"
				onClick={() => {
					if (goToSensorEdit) goToSensorEdit();
					closeDeleteModal();
				}}>
				Discard
			</Button>
			<ActionBarItemGroup
				columns={2}
				elementsWidth={rem(80)}
				gap={'0.5rem'}>
				<Button
					variant="contained"
					onClick={() => {
						closeDeleteModal();
					}}>
					Cancel
				</Button>
				<Button
					variant="contained"
					color="primary"
					onClick={() => {
						if (values) {
							const newValues = values?.points
								.filter(el => el.newValue !== undefined)
								.map(point => ({
									oldValue: point.value.doubleValue,
									newValue: point.newValue as number,
									timeStamp: point.timestamp.timestamp,
									sensorId,
								}));
							dispatch(editSensorDataPoints(newValues));
						}
						closeDeleteModal();
						if (goToSensorEdit) goToSensorEdit();
					}}>
					Save
				</Button>
			</ActionBarItemGroup>
		</>
	);
};
